import styles from "./style.module.scss";
import SuccessMessageImage from "src/assets/success_message.png";
import TakoImage from "src/assets/tako.png";
import WaveImage from "src/assets/wave.png";

const Complete = () => {
  return (
    <>
      <title>石巻マリンヴィレッジ | COMPLETE</title>
      <article className={styles.container}>
        <img src={WaveImage} alt="Wave" className={styles.wave} />
        <div className={styles.innerBox}>
          <img src={TakoImage} alt="Tako" className={styles.tako} />
          <img
            src={SuccessMessageImage}
            alt="COMPLETE"
            className={styles.success}
          />
        </div>
      </article>
    </>
  );
};

export default Complete;
